import styled from 'styled-components';
import { SelectSingle } from 'components/atoms';

export const StyledUserCoinSortSelect = styled.div``;

export const StyledSelectSingle = styled(SelectSingle)`
  width: 100%;
  max-width: 16rem;
`;
